module.exports = __webpack_public_path__ + "static/media/logout-arrow@3x.6326977d.png";